import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Refresh16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M3.25 1H1.75V6.25H7V4.75H4.5358C5.40302 3.82589 6.6344 3.25 8.00002 3.25C10.6234 3.25 12.75 5.37665 12.75 8H14.25C14.25 4.54822 11.4518 1.75 8.00002 1.75C6.09838 1.75 4.39551 2.59973 3.25 3.93791V1Z'
      fill='currentColor'
    />
    <path
      d='M14.25 15H12.75V12.0622C11.6045 13.4003 9.90168 14.25 8.0001 14.25C4.54832 14.25 1.7501 11.4518 1.7501 8H3.2501C3.2501 10.6234 5.37675 12.75 8.0001 12.75C9.36572 12.75 10.5971 12.1741 11.4643 11.25H9V9.75H14.25V15Z'
      fill='currentColor'
    />
  </Svg>
);

Refresh16.displayName = 'Refresh16';
export default Refresh16;
